import { Link, useParams } from "react-router-dom";
import { useAsync } from "../lib/useAsync";
import { useDoctorsApi } from "../lib/doctorsApi";
import { Loading, ErrorState } from "../components/ui";
import { DoctorCard } from "../components/DoctorCard";

// Read-only doctor profile page (/doctors/:id). Renders the shared rich profile card — non-clinical
// identity only (name, specialty, photo, bio, experience, focus, education, languages); no clinical
// data. Sourced from GET /v1/patient/doctors/:id.
export function DoctorProfile() {
  const { id } = useParams<{ id: string }>();
  const doctorsApi = useDoctorsApi();
  const doctor = useAsync(() => doctorsApi.get(id ?? ""), [id]);

  if (doctor.loading) return <Loading />;
  if (doctor.error || !doctor.data) {
    return (
      <>
        <div className="app-page-head">
          <h1>Doctor <em>profile.</em></h1>
        </div>
        <div className="pt-empty">We couldn&rsquo;t find that doctor.</div>
      </>
    );
  }

  return (
    <div className="pt-doc">
      <Link to="/visits" className="pt-vrow__detail" style={{ display: "inline-block", marginBottom: 16 }}>
        &larr; Back to visits
      </Link>
      <DoctorCard
        doctor={doctor.data}
        footer={
          <div className="pt-doc__actions">
            <Link to="/visits/book" className="pt-onbtn pt-onbtn--primary" style={{ background: "var(--red)" }}>
              Book a visit
            </Link>
            <Link to="/messages" className="pt-plan__btn" style={{ background: "var(--cream-2)", color: "var(--ink)", borderColor: "var(--line)" }}>
              Message the care team
            </Link>
          </div>
        }
      />
    </div>
  );
}
